import {Box, Notification, Paragraph} from '@constellation/core';
import {memo} from 'react';
import {JOURNEY_EVENT} from '../../../../enums/tagging/index.js';
import {ROUTE_PATHS} from '../../../../utils/constants/public/psr.js';
import getPsrLabel from '../../../../utils/getPsrLabel.js';
import {Button} from '../../../common/Analytics/Tagging/index.js';
import {NotificationWrapper} from './Styles/Styles.js';

const SystemFailure = memo(() => (
  <Box bgColor='neutral2' data-testid='systemFailure'>
    <NotificationWrapper>
      <Notification
        heading={getPsrLabel('systemFailure.notification.heading')}
        headingLevel={2}
        marginBottom='07'
        marginTop='none'
        sentiment='critical'
      >
        <Paragraph marginBottom='none'>
          {getPsrLabel('systemFailure.notification.body')}
        </Paragraph>
      </Notification>
    </NotificationWrapper>
    <Button
      aria-label={getPsrLabel('systemFailure.returnToCardnetSrText')}
      data-testid='sfButton'
      href={ROUTE_PATHS.CARDNET_LANDING_PAGE}
      journeyEvent={JOURNEY_EVENT.EXTERNAL_CLICK}
      taggingLabel=''
    >
      {getPsrLabel('systemFailure.returnToCardnet')}
    </Button>
  </Box>
));

export default SystemFailure;
